// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"eb5f1dd595d04da1c27c","691":"5142987222c82bcfca07"}[chunkId] + ".js";
};